﻿<rdo-breadcrumb></rdo-breadcrumb>
<div  id="sales-rep" [rdoFillRemainingHeight]>
  <div class="d-flex flex-row position-relative align-items-stretch scroll-container" [rdoCollapsedCards]="'sales-rep'">
    <rdo-collapsible [key]="'sales-rep'">
      <div class="rdo-col-card-fixed scroll"
        infinite-scroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="500"
        (scrolled)="getPaginatedCards()"
        [scrollWindow]="false">
        <div class="rdo-card-list">
          @for (c of salesRepCards; track c; let baseId = $index) {
            <rdo-nav-card-book
              [baseId]="baseId"
              [data]="c"
              [titleSelector]="'SalesRepName'"
              [selected]="isSelected(c)"
              [icon]="'fa-user'"
              [comparisonMode]="mode"
              (selectedChange)="select(c)"
              [rdo-scroll-into]="isSelected(c)">
            </rdo-nav-card-book>
          }
        </div>
      </div>
    </rdo-collapsible>
    <div class="rdo-col-card-offset container-fluid scroll-container collapsible-offset">
      <div class="row">
        <div class="col-12">
          <h3>
            <i class="fa fa-user"></i>
            {{selectedSalesRep?.SalesRepName}}
          </h3>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <ul class="nav nav-pills rdo-nav-pills">
            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" id="{{'main.core.common.dashboard' | rdoPathToId}}" class="nav-item">
              <a [routerLink]="['./']" [attr.data-text]="'main.core.common.dashboard' | translate" class="nav-link">{{'main.core.common.dashboard' | translate}}</a>
            </li>
            <li routerLinkActive="active" id="{{'main.core.common.counts.customers.plural.button' | rdoPathToId}}" class="nav-item">
              <a [routerLink]="['customers']" [attr.data-text]="'main.core.common.counts.customers.plural' | translate" class="nav-link">{{'main.core.common.counts.customers.plural' | translate}}</a>
            </li>
            <li routerLinkActive="active" id="{{'main.core.common.counts.product_types.plural.button' | rdoPathToId}}" class="nav-item">
              <a [routerLink]="['product-types']" [attr.data-text]="'main.core.common.counts.product_types.plural' | translate" class="nav-link">{{'main.core.common.counts.product_types.plural' | translate}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row" id="sales-rep-content">
        <div class="scroll-container col-12">
          <div class="active container-fluid" [class.scroll]="shouldScroll()">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
